import useRoutes from '@/hooks/useRoutes';
import { SectionData } from '@/types';
import { Link } from '@inertiajs/react';
import React from 'react';

interface QuickAccessSectionProps {
    section: SectionData;
    courseSlug: string;
}

const QuickAccessSection: React.FC<QuickAccessSectionProps> = ({
    section,
    courseSlug,
}) => {
    const { route } = useRoutes();
    const sectionUrl = route('section-detail', {
        slug: courseSlug,
        section_id: section.id,
    }).toString();

    return (
        <Link
            href={sectionUrl}
            className="group relative flex aspect-[2/1] items-center justify-center overflow-hidden rounded-xl bg-white p-4 shadow-sm ring-1 ring-gray-200/60 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:ring-emerald-300/50"
        >
            <img
                src={section.icon_url}
                alt={section.title}
                className="h-full max-h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-emerald-500/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        </Link>
    );
};

export default QuickAccessSection;
